export default function simpleToolbarTitle(isOperator) {
  const path = window.location.pathname;
  if (path.startsWith("/zones/update/")) return "Actualizar zonas de visita";
  if (path.startsWith("/zones/representative/update/"))
    return "Actualizar datos de representante";
  if (path.startsWith("/refill/update"))
    return "Actualizar categoria de auto relleno";
  if (path.startsWith("/refill/create"))
    return "Agregar categoria de auto relleno";
  switch (path) {
    case "/":
      return isOperator ? "Asignaciones" : "Medicos";
    case "/doctors-approval":
      return "Aprobar Medicos";
    case "/active-doctors":
      return "Medicos activos";
    case "/laboratories":
      return "Laboratorios";
    case "/products-approval":
      return "Aprobar productos";
    case "/users":
      return "Usuarios";
    case "/operators":
      return "Operadores";
    case "/doctor-assignments-top":
      return "Medicos con mas asignaciones";
    case "/most-requested-products":
      return "Productos mas solicitados";
    case "/reports":
      return "Reportes";
    case "/categories":
      return "Categorias";
    case "/products":
      return "Productos";
    case "/assignments":
      return "Asignación de muestras a médicos";
    case "/assignments-to-patients":
      return "Asignación de muestras a pacientes";
    case "/assign-to-operator":
      return "Seguimiento de entrega de muestras médicas";
    case "/orders":
      return "Aprobar ordenes";
    case "/business-units":
      return "Unidad de negocios";
    case "/patients-repetition-rate":
      return "Indice de repetición de pacientes";
    case "/samples-to-run-out":
      return "Muestras por agotarse";
    case "/samples-available":
      return "Muestras disponibles";
    case "/history":
      return "Historial";
    case "/assign-to-representative":
      return "Asignar muestra a representante";
    case "/zones":
      return "Zonas de visita";
    case "/refill":
      return "Categorias de auto relleno";
    case "/refill/doctors":
      return "Categorias asignadas a médicos ";
    case "/zones/assignment":
      return "Asignar zonas de visita ";
    case "/zones/create":
      return "Agregar zonas de visita ";
    case "/zones/representative":
      return "Asignación de zonas a representantes";
    case "/zones/representative/create":
      return "Agregar representante ";
    case "/zones/doctors":
      return "Asignación de zonas a doctores";
    case "/zones/doctors/zonify":
      return "Asignar zonas a doctores por excel";
    case "/consent":
      return "Consentimiento informado";
    case "/assign-to-doctors":
      return "Asignar muestras a médicos ";
    case "/assignments-wrong-address":
      return "Asignaciones con dirección errónea";
    default:
      return "";
  }
}
